<div class="page-container">
  <div class="header-row">
    <h1>{{ title }}</h1>
    <div class="buttons">
      <button class="new-app-btn" mat-raised-button (click)="newApp()" [disabled]="isSuspended"><span class="material-icons">add</span> New Application</button>
    </div>
  </div>

  <div class="table-container">
    <div class="table-header">
      <h2>Invitations</h2>
      <app-table-header-actions name="invites" (exportEvent)="export($event)">
      </app-table-header-actions>
    </div>
    <app-invite-page></app-invite-page>
  </div>
  
  <div class="table-container">
    <div class="table-header">
      <h2>Applications</h2>
      <app-table-header-actions name="applications" (exportEvent)="export($event)">
      </app-table-header-actions>
    </div>
    <app-applications></app-applications>
  </div>
</div>
